import React from "react";
import Header from "../../appLayout/header";
import { Row } from "react-bootstrap";
import "./index.scss";
export const SlideSimulation = () => {
  return (
    <div className="slide-simulation">
      <div className="header-simulation pt-5">
        <Header />
      </div>
      <div className="slide-simulation-container  p-5  px-0 px-md-5">
        <Row className="align-items-center justify-content-center gx-0  h-100 p-5">
          <h1 className="slide-title ">
            Votre meilleure simulation commence ici
          </h1>

          <p className="text-slide mt-3">
            Un outil exclusif développé par notre cabinet de conseil pour
            visualiser votre potentiel de croissance.
          </p>
        </Row>
      </div>
    </div>
  );
};
